// Themed metatemplates for InputType 'Picker' (pict-section-picker via the Headlight Picker provider).
// Mirrors InputType-EntitySelectorMultiple.js's Bulma chrome (column / field / label / help) so the
// picker inherits Headlight's form styling + the row's flex alignment — only the control differs: a
// host element the picker renders into, where the <select> used to be.
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME — interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
			<!-- InputType Picker {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					{~Required:Record~}
					data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
					value=""
				/>
				<div class="field">
					<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
						class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
						title="Show all (ignore filters)"
						onclick="_Pict.providers.Picker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
						<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
					</a>
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML*/`
			<!-- InputType Picker {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							data-validation-surface="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<div class="field">
							<p class="control control-status">
								<span class="control-status-icon"></span>
								<span id="PICKER-FOR-{~D:Record.Macro.RawHTMLID~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~}></span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			// Tabular (one picker per RecordSet row). Split Begin/End so the row's informary attributes
			// inject into the hidden input; the picker provider mounts into the PICKER-TABULAR host below.
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							value=""
						/>
						<input
							id="PICKER-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							type="hidden"
							tabindex="-1"
							{~Required:Record~}
							data-validation-surface="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			DefaultInputExtensions: [ 'Picker' ],
			Template: /*HTML-Partial*/`
							value="" />
						<a id="PICKER-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							class="button is-ghost is-pulled-right p-0 is-size-7 hl-tabular-filter-toggle {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
							title="Show all (ignore filters)"
							onclick="_Pict.providers.Picker.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.Hash~}', '{~D:Context[2].Key~}')">
							<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
						</a>
						<span id="PICKER-TABULAR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}" class="pps-form-host" {~D:Record.Macro.ControlAttr~} data-i-index="{~D:Context[2].Key~}"></span>
					</p>
				</div>`,
		},
	],
	/* READ THEME — locked / non-interactive in-browser state. A static resolved-value display painted by
	   the PickerDisplay provider (not the interactive picker), styled as a locked control. */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType Picker (read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- InputType Picker (read display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-3">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="field">
								<p class="control">
									<div id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="textarea" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~} disabled="disabled"></div>
								</p>
							</div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular read display) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="field mb-0">
					<p class="control">
						<div
							id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
							class="textarea"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.HTMLName~}
							{~D:Record.Macro.InformaryTabular~}
							disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			Template: /*HTML-Partial*/`
						></div>
					</p>
				</div>`,
		},
	],
	/* PRINT THEME — non-interactive PDF. Same resolved value, painted by PickerDisplay into a static node
	   styled for PDF output (independent of the Read theme's locked-control look). */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType Picker (print display) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
				<!-- InputType Picker (print display, vertical) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
					<div class="columns is-mobile is-vcentered">
						<div class="column">
							<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
						</div>
						<div class="column description-text">{~D:Record.Description~}</div>
						<div class="column">
							<div class="input is-static wrap-selections-for-print" id="PICKER-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" {~D:Record.Macro.ControlAttr~} {~D:Record.Macro.InputFullProperties~}></div>
						</div>
					</div>
				</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Picker',
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
				<!-- InputType Picker (tabular print display) {~D:Record.Hash~} {~D:Record.DataType~} -->
				<div
					id="PICKER-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="input is-static wrap-selections-for-print"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Picker',
			Template: /*HTML-Partial*/`
				></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
